<template>
  <div class="form-group">
    <div class="text-nowrap d-flex">
      <label
        v-if="label"
        :for="name"
        :title="required ? trans('terms.required') : ''"
        class="form__label flex-grow-1"
      >{{ label }}<span v-if="required"> *</span></label>
    </div>
    <div
      :class="{ 'is-invalid': errors.length > 0 }"
      class="form__input-wrapper"
    >
      <slot />
    </div>
    <div
      v-if="errors.length > 0"
      class="invalid-feedback order-1"
    >
      {{ errorText }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'VInputWrapper',
  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
      default: null,
    },
    errors: {
      required: false,
      default: () => ([]),
      type: Array,
    },
    required: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  computed: {
    errorText () {
      return this.errors.map(e => e.message).join(' ')
    },
  },
}
</script>

<style lang="scss" scoped>
.is-invalid{
  border-color: #dc3545;
  border-width: 1px;
  border-style: solid;
}
.invalid-feedback {
  color: #dc3545;
}
</style>
